import { useTzDate } from '@/composable/useTzDate'
import { capitalize } from 'lodash'
import { ref } from 'vue'

export function useSplashesCellFormatter() {
  const { dateFullStr } = useTzDate()
  const formattingRules = ref({
    symbol: (v: any) => {
      return v.split('/')[0]
    },
    grp: (v: any) => {
      return `${v}%`
    },
    exchange: (v: any) => {
      return capitalize(v)
    },
    last_signal_ts: (isoString: any) => {
      const normalized =
        isoString.endsWith('Z') || /[+\-]\d{2}:\d{2}$/.test(isoString)
          ? isoString
          : `${isoString}Z`
      return dateFullStr(normalized)
    },
  })

  return { formattingRules }
}
